import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH LIMIT TO EDIT ********************
export const fetchLimit = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_LIMIT_LOADING,
			payload: true
		});

		const { data } = await services.get(`/player/limits/${id}/get`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_LIMIT_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_LIMIT_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
